import {
    ArrowsUpDownIcon,
    EyeIcon,
    PencilSquareIcon,
    StarIcon,
} from '@heroicons/react/16/solid';

export const getAccessDisplay = (access) => {
    switch (access) {
        case 'viewer':
            return {
                icon: EyeIcon,
                text: 'Viewer',
                color: '#233AC6',
            };
        case 'admin':
            return {
                icon: StarIcon,
                text: 'Admin',
                color: '#233AC6',
            };
        case 'mixed':
            return {
                icon: ArrowsUpDownIcon,
                text: 'Mixed',
                color: '#233AC6',
            };
        default:
            return { text: 'No Access', color: '#d9d9d9' };
    }
};
